import { Text, type TextProps, Tooltip, TooltipTrigger } from "@hopper-ui/components";
import type { AriaRole, ComponentProps, ComponentType } from "react";
import { Truncatable, useIsTruncated } from "../table/cells/utils/useIsTruncated.tsx";

export const textEllipsisProps = {
    display: "inline-block",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
} as TextProps;

export type TruncatableTextProps<T extends ComponentType<Record<string, unknown>> = typeof Text> = {
    text: string;
    as?: T;
    role?: AriaRole | false;
} & Omit<ComponentProps<T>, "children">;

export function TruncatableText<T extends ComponentType<Record<string, unknown>> = typeof Text>({
    text,
    as,
    role,
    ...textProps
}: TruncatableTextProps<T>) {
    const [ref, isTruncated] = useIsTruncated();
    const Component = (as ?? Text) as ComponentType<Record<string, unknown>>;

    return (
        <TooltipTrigger isDisabled={!isTruncated}>
            <Truncatable ref={ref} isTruncated={isTruncated} role={role}>
                <Component {...textEllipsisProps} {...textProps}>
                    {text}
                </Component>
            </Truncatable>
            <Tooltip>{text}</Tooltip>
        </TooltipTrigger>
    );
}
